import OWContainer from 'styles/styled-components/ow-container';
import { TerminalForm } from '../components/terminal-form';
import useController from '../controllers/edit-terminal-controller';
import { Spinner } from 'components/design';

export const EditTerminalRoute = () => {
    const { errors, isLoading, onCancel, onChange, onSubmit, formData, dataChanged, isEditTerminalLoading } =
        useController();

    return (
        <OWContainer>
            {isLoading ? (
                <Spinner />
            ) : (
                <TerminalForm
                    formData={formData}
                    errors={errors}
                    onCancel={onCancel}
                    onChange={onChange}
                    onSubmit={onSubmit}
                    disableSubmit={!dataChanged}
                    isSaveLoading={isEditTerminalLoading}
                    isEdit={true}
                />
            )}
        </OWContainer>
    );
};
